// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"62":"56204833","94":"eff3f91c","154":"7a49fe7f","348":"7fe1ea69","462":"7c80d640","807":"4c030396","850":"12df45c0"}[chunkId] + ".chunk.js";
};